// @ts-nocheck
import { Column } from 'react-table';
import { SubscriptionCustomCell } from './SubscriptionCustomCell';
import { SubscriptionCustomHeader } from './SubscriptionCustomHeader';

const subscriptionsColumns: ReadonlyArray<Column<SubscriptionDto>> = [
	{
		Header: props => (
			<SubscriptionCustomHeader
				tableProps={props}
				title='UUID'
				className='min-w-125px'
			/>
		),
		id: 'uuid',
		Cell: ({ ...props }) => (
			<SubscriptionCustomCell value={props.data[props.row.index]?.uuid} />
		),
	},

	{
		Header: props => (
			<SubscriptionCustomHeader
				tableProps={props}
				title='Имя'
				className='min-w-100px'
			/>
		),
		id: 'name',
		Cell: ({ ...props }) => (
			<SubscriptionCustomCell value={props.data[props.row.index]?.name} />
		),
	},
	{
		Header: props => (
			<SubscriptionCustomHeader
				tableProps={props}
				title='Тип'
				className='min-w-100px'
			/>
		),
		id: 'type',
		Cell: ({ ...props }) => (
			<SubscriptionCustomCell value={props.data[props.row.index]?.type} />
		),
	},
	{
		Header: props => (
			<SubscriptionCustomHeader
				tableProps={props}
				title='Цена'
				className='min-w-100px'
			/>
		),
		id: 'price_cents',
		Cell: ({ ...props }) => (
			<SubscriptionCustomCell value={`$${(props.data[props.row.index]?.price_cents / 100).toFixed(2)}`} />
		),
	},
	{
		Header: props => (
			<SubscriptionCustomHeader
				tableProps={props}
				title='Длительность'
				className='min-w-100px'
			/>
		),
		id: 'duration_days',
		Cell: ({ ...props }) => (
			<SubscriptionCustomCell value={props.data[props.row.index]?.duration_days} />
		),
	},
	{
		Header: props => (
			<SubscriptionCustomHeader
				tableProps={props}
				title='Статус'
				className='min-w-100px'
			/>
		),
		id: 'active',
		Cell: ({ ...props }) => (
			<SubscriptionCustomCell value={String(props.data[props.row.index]?.active)} />
		),
	},
];

export { subscriptionsColumns };
